import { fetchV1, fetchAdminV1 } from "../lib/requester/v1";

export function getAll(params) {
	return fetchV1("/faqs", { method: "GET", data: params });
}

export function create(data) {
	return fetchAdminV1(`/faqs`, { method: "POST", data });
}

export function update(data) {
	return fetchAdminV1(`/faqs/${data.id}`, { method: "PUT", data });
}

export function remove(id) {
	return fetchAdminV1(`/faqs/${id}`, { method: "DELETE" });
}
